export default __webpack_public_path__ + "static/about-img14-bd15c3ab98ba87786affea305918bf47.png";